import React from "react";
import storeContext from "../store";

export const useStores = () => React.useContext(storeContext);